var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternalLias01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    "data-name": "Laag 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28.35 23.66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.37,0c.57,1,5.88,11.11,6.3,11C9.8,14.59,7.37,16.64.08,23.62L0,23.6A101.58,101.58,0,0,1,15.37,0",
    fill: "#d60929"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.17,12.89l6.18,10.77H14.1c-3.28-3.91,2.45-8.09,8.07-10.77",
    fill: "#4b5054"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLias01);
export default __webpack_public_path__ + "static/media/External_LIAS-01.09ae079a28d46745a0f8aa07759d3641.svg";
export { ForwardRef as ReactComponent };